import { render, staticRenderFns } from "./MyTradesView.vue?vue&type=template&id=40d30e38&scoped=true&"
import script from "./MyTradesView.vue?vue&type=script&lang=ts&"
export * from "./MyTradesView.vue?vue&type=script&lang=ts&"
import style0 from "./MyTradesView.vue?vue&type=style&index=0&id=40d30e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d30e38",
  null
  
)

export default component.exports